import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import classnames from 'classnames';

import {
    withStyles,
} from '@material-ui/core';

import Header from './Header';
import Footer from './Footer';

export const contentWidth = 1080;
export const headerHeight = 80;

const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    header: {
        width: '100%',
        height: headerHeight,
    },
    content: {
        flex: '1 1 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.colors.grey2,
        padding: theme.spacing(8),

        '&$fullPage': {
            alignItems: 'normal',
        },

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(6, 2),
        },
    },
    fullPage: {
    },
    center: {
        border: theme.borders.green,
        padding: theme.spacing(3),
        background: theme.colors.grey1,
        minWidth: 400,
        maxWidth: contentWidth,
        minHeight: 260,

        '$fullPage &': {
            flex: '1 1 auto',
        },

        [theme.breakpoints.down('xs')]: {
            minWidth: 0,
            width: '100%',
        },
    },
});

class Layout extends React.Component {
    render() {
        const {
            classes, children, headerProps, fullPage,
        } = this.props;

        return (
            <div className={classnames(classes.root)}>
                <Header className={classes.header} {...headerProps} />

                <div className={classnames(classes.content, { [classes.fullPage]: fullPage })}>
                    {children && (
                        <div className={classnames(classes.center)}>
                            {children}
                        </div>
                    )}
                </div>

                <Footer />
            </div>
        );
    }
}

Layout.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    headerProps: PropTypes.object,
    fullPage: PropTypes.bool,
};

Layout.defaultProps = {
    headerProps: null,
    fullPage: false,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(Layout));
